module.exports = new __parcel__URL__("ITSM Runbook Hover.dfaa2fae.svg").toString();